<template>
  <div class="giude-withdraw" :class="[status]" v-if="tips.show === 'Y'" @click="goWithdraw"
       data-sensors-exposure-property-element_positon="banner"
       data-sensors-exposure-event-name="Element_Exposure"
  >
    {{ tips.tipDesc }} >
    <i class="light"></i>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    status: {
      type: String,
      default: 'IN_PROGRESS'
    }
  },
  data () {
    return {
      tips: {},
      repayId: this.$route.query.repayId
    }
  },
  mounted () {
    this.getRePayTips()
  },
  methods: {
    goWithdraw () {
      this.$sensors.track('$WebClick', { element_type: 'repayment_result', element_content: this.tips.tipDesc })
      this.$router.push('/middle/limit')
    },
    ...mapActions('repay', [
      'repayTipsX'
    ]),
    async getRePayTips () {
      const { success, data } = await this.repayTipsX({
        repayId: this.repayId
      })
      if (success) {
        this.tips = data
      }
    } 
  }
    
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.giude-withdraw {
  width: 690px;
  height: 80px;
  background: #FFF4E8;
  border-radius: 20px;
  color: #932A05;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin:30px auto;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  overflow: hidden;
  position: relative;
  &.SUCCESS {
    background: #EFF9F1;
    color: #106B23;
  }
  .light {
    position: absolute;
    width: 300px;
    height: 100%;
    top: 0;
    left: -100px; /* 初始位置在容器外 */
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: skewX(-20deg); /* 倾斜效果使光效看起来更自然 */
    animation: lightSweep 2s infinite linear; /* 3秒循环动画 */
  }
  @keyframes lightSweep {
    0% {
      left: -100px; /* 开始于容器左侧外部 */
    }
    100% {
      left: 800px; /* 结束于容器右侧外部 */
    }
  }
}
</style>